import {Box, SvgIcon, SvgIconProps} from "@mui/material";

export interface TrainIconProps extends SvgIconProps {
    scolor?: string;
}

const HeatMapIcon = ({scolor = "#78909C", ...props}: TrainIconProps) => {
    return (
          <SvgIcon style={{fill: "none"}} {...props}>

    <Box strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                 d="M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
                 component="path" sx={{
                                         stroke: scolor,
                                         '&:hover': {
                                             stroke: 'white', // Background color on hover
                                         },
                                     }}/>


        </SvgIcon>





    );
};

export default HeatMapIcon;


